'use client';

import { useEffect, useState } from 'react';

import { StateSprite } from '~/components/common/give-happiness/state-sprite';
import { Link } from '~/components/common/link';
import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';

const CYCLING_STATES = [
  { name: 'California' },
  { name: 'Texas' },
  { name: 'Florida' },
  { name: 'New York' },
  { name: 'Pennsylvania' },
  { name: 'Illinois' },
  { name: 'Ohio' },
  { name: 'Michigan' },
] as const;

export function GeoFallback() {
  const [currentStateIndex, setCurrentStateIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const currentState = CYCLING_STATES[currentStateIndex];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);

      setTimeout(() => {
        setCurrentStateIndex((prev) => (prev + 1) % CYCLING_STATES.length);
        setIsAnimating(false);
      }, 300); // Half the animation duration
    }, 3000); // Change state every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className='container xl:max-w-7xl'>
      <div className='flex items-center max-md:flex-col max-md:gap-y-5 md:justify-between md:gap-x-8 lg:gap-x-14'>
        <figure className='max-md:w-full md:flex-1 md:self-start'>
          <div
            className={cn(
              'transition-all duration-500 ease-in-out',
              isAnimating ? 'scale-95 opacity-60' : 'scale-100 opacity-100',
            )}
          >
            <StateSprite state={currentState.name} className='h-auto w-full' />
          </div>
          <figcaption className='sr-only'>We support facilities in {currentState.name}!</figcaption>
        </figure>

        <div className='max-md:w-full md:flex-1'>
          <h2 className='heading-base'>
            <span className='text-muted-foreground'>We&apos;re helping kids across the country, including in </span>
            <span className={cn('transition-all duration-500 ease-in-out', isAnimating ? 'opacity-60' : 'opacity-100')}>
              {currentState.name}
            </span>
          </h2>
          <p className='text-muted-foreground body-lg mt-3 leading-7 lg:mt-6'>
            Starlight supports hundreds of hospitals and medical facilities across all 50 states, bringing joy and
            comfort to children facing medical challenges everywhere.
          </p>

          <Button className='mt-5 lg:mt-7' variant='outline' asChild>
            <Link href='/impact'>Search Our Hospitals</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
